<template>
	<div id="user-container">
		<img class="user-img-container" :src="getGravatar(user.email)" alt="" />
		<v-menu :content-class="'account-menu--theme --app'" min-width="200" offset-y nudge-bottom="15">
			<template v-slot:activator="{ on, attrs }">
				<div class="user-label-container" v-bind="attrs" v-on="on" :class="{'--unread-notifications': notificationsOfNonActiveOrganization.length > 0}">
					<span class="name">{{ user.name }}</span>
					<i class="material-icons">arrow_drop_down</i>
				</div>
			</template>

			<div class="account-menu-content">
				<div class="active-account">
					<span class="organization">{{ account.organization.name }}</span>
					<span class="role">{{ getRoleName(account.role_id) }}</span>
				</div>

				<AccountSwitch />

				<v-list>
					<v-list-item class="navigation-link">
						<BackToApp />
					</v-list-item>
					<v-list-item>
						<router-link :to="{ name: 'account.profile' }">Account</router-link>
					</v-list-item>
					<v-list-item>
						<Logout />
					</v-list-item>
				</v-list>
			</div>
		</v-menu>
	</div>
</template>

<script>
// import AvatarMixins from "@/mixins/Avatar";
import { mapState, mapGetters } from "vuex";
import AvatarMixins from "@/mixins/Avatar";

import AccountSwitch from "@/components/account-menu/Switch";
import Logout from "@/components/account-menu/Logout";
import BackToApp from "@/components/account-menu/BackToApp";

export default {
	name: "User",
	mixins: [AvatarMixins],
	components: {
		AccountSwitch,
		Logout,
		BackToApp,
	},
	data: function() {
		return {};
	},
	computed: {
		...mapState("Auth", ["authenticated"]),
		...mapState("User", ["account", "user"]),
		...mapGetters("Roles", ["getRoleName"]),
        ...mapGetters('Notifications', ['notificationsOfNonActiveOrganization']),
    },
};
</script>

<style lang="scss">
#user-container {
	display: flex;
	align-items: center;
	cursor: pointer;
	color: var(--font-default-color);

	> .user-img-container {
		height: 35px;
		width: 35px;
		border-radius: 50%;
		background-color: white;
		// background-size: cover;
		background-size: contain;
		background-repeat: no-repeat;
		background-position: center;
		border: 2px solid #8c54e9;
	}

	> .user-label-container {
		display: flex;
		align-items: center;
		margin: 0 7px;
		font-size: 13px;
        position: relative;
		.name {
			line-height: 1;
		}
		i {
			font-size: 18px;
		}

        &.--unread-notifications {
            &:before {
                content: "";
                display: block;
                position: absolute;
                top: -5px;
                right: 7px;
                width: 4px;
                height: 4px;
                background: var(--primary);
                border-radius: 50%;
            }
        }
	}
}

.account-menu--theme {
	&.--app {
		border-radius: var(--box-rounding);
		contain: initial;
		overflow: visible;

		&::before {
			position: absolute;
			content: "";
			top: 0;
			left: 20px;
			transform: translateY(-100%);
			width: 10px;
			height: 13px;
			border-left: 10px solid transparent;
			border-right: 10px solid transparent;
			border-bottom: 13px solid var(--dark-gray);
		}
	}

	.account-menu-content {
		font-size: 12px;
		color: #989898;
		border-radius: var(--box-rounding);
		background: var(--dark-gray);

		.active-account {
			padding: 25px;
			display: flex;
			flex-direction: column;
			.organization {
				line-height: 20px;
				font-weight: bold;
				font-size: 16px;
			}
			.role {
				line-height: 1;
				font-size: 14px;
			}
		}

		.v-list {
			background: var(--dark-gray);
			padding: 25px 0;
			border-radius: var(--box-rounding);

			.v-list-item {
				display: flex;
				justify-content: stretch;
				min-height: 24px;
				padding: 0 25px;
				font-size: 12px;
				&:hover {
					background: #363636;
				}
				> a {
					display: block;
					line-height: 2;
					width: 100%;
				}

				&.navigation-link {
					color: #989898 !important;
				}
			}
		}

		a {
			color: #989898;
			text-decoration: none;
			&:hover {
				color: #b9b9b9;
				transition: color 0.5s ease;
			}
		}
	}
}
</style>
